<template>
  <v-app>
    <v-app-bar app>
      <router-link class="title text-uppercase link" to="/" link>
        <v-toolbar-title>Game Night</v-toolbar-title>
        <!-- <span class="font-weight-light">a website</span> -->
      </router-link>
      <v-spacer></v-spacer>
      <router-link link class="link" to="codenames">
        <div>Codenames</div>
      </router-link>
      <!-- <v-btn text href="https://github.com/vuetifyjs/vuetify/releases/latest" target="_blank">
        <span class="mr-2">Latest Release</span>
      </v-btn>-->
    </v-app-bar>

    <v-content>
      <router-view />
    </v-content>
  </v-app>
</template>

<script>
import Home from "./views/Home";

export default {
  name: "App",
  components: {
    Home
  },
  mounted() {
    console.log("mounted");
    this.wordbank.forEach(word => {
      console.log(word);
      this.words[word] = { guessed: false, team: "red" };
    });
  },
  data() {
    return {
      wordbank: ["donkey", "cow", "elephant"],
      words: {}
    };
  }
};
</script>
<style lang="scss" >
.v-application a {
  // color: red;
  text-decoration: none;
  color: black;
  & > div {
    color: black;
  }
}
.title {
  color: black;
}
</style>
